import(/* webpackMode: "eager" */ "/vercel/path0/app/image-resizer/page.tsx");
